import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/services/api/configuration.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FabricService } from 'src/app/services/fabric/fabric.service';
import { DownloadService } from 'src/app/services/util/download.service';
import { translate } from '@jsverse/transloco';
import { ToastrService as ToastrLibService } from 'ngx-toastr';

const SERVICE_NAME = 'crvt-resources';

@Injectable({
  providedIn: 'root'
})
export class CRVTService {

  constructor(private fabricService: FabricService, private downloadService: DownloadService,
    private httpClient: HttpClient, private configurationService: ConfigurationService,
    private authService: AuthService, private toastr: ToastrLibService) {
  }

  getCRVTToken(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_crvt_token');
  }

  downloadCRVT(blueprintId: string, instanceId: string, runId: string, filename: string): Observable<any> {
    this.showSuccess();
    return combineLatest([this.configurationService.getConfiguration(), this.getCRVTToken()])
    .pipe(
      mergeMap(([config, tokenResponse]) => {
        let downloadUrl = `${config.crvtUrl}/crvt/test-results/download/`;
        downloadUrl += `${blueprintId}/${instanceId}/${runId}/${filename}`;
        const options = {
          observe: 'response' as 'events',
          responseType: 'blob' as 'json',
          headers: {Authorization: `Bearer ${tokenResponse.value}`}
        };
        return this.httpClient.get<HttpResponse<Blob>>(downloadUrl, options);
      }),
      // tap(response => this.downloadService.download(filename, response)));
      tap(response => this.downloadService.download(response)));
  }

  downloadReleasePack(pack: string, blueprintId: string, filename: string): Observable<any> {
    return combineLatest([this.configurationService.getConfiguration(), this.getCRVTToken()])
    .pipe(
      mergeMap(([config, tokenResponse]) => {
        let downloadUrl = `${config.crvtUrl}/crvt/${pack}/download/`;
        downloadUrl += `${blueprintId}/${filename}`;
        const options = {
          observe: 'response' as 'events',
          responseType: 'blob' as 'json',
          headers: {Authorization: `Bearer ${tokenResponse.value}`}
        };
        return this.httpClient.get<HttpResponse<Blob>>(downloadUrl, options);
      }),
      tap(response => this.downloadService.download(response)));
  }

  getViewResultsUrl(blueprintId: string, instanceId: string, runId: string, filename: string): Observable<string> {
    return this.configurationService.getConfiguration()
    .pipe(map((config) => {
      let viewUrl = `${config.crvtUrl}/crvt/results-view/`;
      viewUrl += `${this.authService.principal.provider}/${blueprintId}/${instanceId}/${runId}/${filename}`;
      return viewUrl;
    }));
  }

  showSuccess() {
   this.toastr.success(translate('CRVT.FILE_DOWNLOAD'), '' , {
    toastClass: 'custom-toast',
    timeOut: 1000,
    extendedTimeOut: 0,
    tapToDismiss: false,
    positionClass: 'toast-top-right',
  });
  }
}
